import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { BRAND, NAV_LINKS } from "../data/content";
import { track } from "../lib/tracking";

const LEGAL = [
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Terms of Use", to: "/terms-of-use" },
  { label: "Disclaimer", to: "/disclaimer" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-gold/15 bg-navy/40 pb-24 md:pb-0">
    <div className="container-x grid gap-12 py-16 md:grid-cols-2 lg:grid-cols-4">
      <div>
        <div className="flex flex-col leading-none">
          <span className="font-display text-xl tracking-[0.22em] text-ivory">CELEBRITY</span>
          <span className="mt-1 text-[10px] font-semibold uppercase tracking-[0.55em] text-gold">Bouncers</span>
        </div>
        <p className="mt-5 text-sm leading-relaxed text-steel">
          {BRAND.tagline}
          <br />
          {BRAND.region}
        </p>
        <p className="mt-5 font-serif text-sm italic text-ivory/50">
          Presence. Precision. Privacy. Hospitality.
        </p>
      </div>
      <div>
        <h3 className="eyebrow">Contact</h3>
        <ul className="mt-5 space-y-4 text-sm text-steel">
          <li>
            <a
              href={BRAND.phonePrimaryHref}
              data-testid="footer-phone-link"
              onClick={() => track("call_click", { placement: "footer" })}
              className="flex items-start gap-3 transition-colors duration-300 hover:text-gold"
            >
              <Phone size={15} className="mt-0.5 shrink-0 text-gold" />
              <span>
                {BRAND.phonePrimary}
                <br />
                <span className="text-xs">Alternate: {BRAND.phoneSecondary}</span>
              </span>
            </a>
          </li>
          <li>
            <a
              href={`mailto:${BRAND.email}`}
              data-testid="footer-email-link"
              className="flex items-start gap-3 transition-colors duration-300 hover:text-gold"
            >
              <Mail size={15} className="mt-0.5 shrink-0 text-gold" />
              {BRAND.email}
            </a>
          </li>
          <li>
            <a
              href={BRAND.directions}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-directions-link"
              onClick={() => track("directions_click", { placement: "footer" })}
              className="flex items-start gap-3 transition-colors duration-300 hover:text-gold"
            >
              <MapPin size={15} className="mt-0.5 shrink-0 text-gold" />
              {BRAND.address}
            </a>
          </li>
        </ul>
      </div>
      <div>
        <h3 className="eyebrow">Explore</h3>
        <ul className="mt-5 space-y-3 text-sm">
          {NAV_LINKS.filter((l) => l.to !== "/").map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                data-testid={`footer-${l.label.toLowerCase()}-link`}
                className="text-steel transition-colors duration-300 hover:text-gold"
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <h3 className="eyebrow">Legal</h3>
        <ul className="mt-5 space-y-3 text-sm">
          {LEGAL.map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                data-testid={`footer-${l.label.toLowerCase().replace(/\s+/g, "-")}-link`}
                className="text-steel transition-colors duration-300 hover:text-gold"
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
        <p className="mt-6 text-xs leading-relaxed text-steel/60">
          Official social media profiles will be linked here once active.
        </p>
      </div>
    </div>
    <div className="border-t border-white/5">
      <div className="container-x flex flex-col gap-2 py-6 text-xs text-steel/60 sm:flex-row sm:items-center sm:justify-between">
        <span>© {new Date().getFullYear()} Celebrity Bouncers. All rights reserved.</span>
        <span>CelebrityBouncers.com · Vijayawada, Andhra Pradesh</span>
      </div>
    </div>
  </footer>
);
